import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, EditLocation, Add, Map } from '@material-ui/icons';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

import ModalMapRouteEdit from './Maps/ModalMapRouteEdit';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import ButtonDelete from 'hooks/ButtonDelete';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Código', accessor: 'code', width: 100 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'layerColor', width: 25 },
  { Header: 'Capa', accessor: 'layer', width: 150 },
  { Header: 'Zona', accessor: 'zone', width: 150 },
  { Header: 'Polígono', accessor: 'polygon', width: 150 },
  { Header: 'Validar Gps', accessor: 'validate_gps', width: 110 },
  { Header: 'Varios vendedores', accessor: 'multiple_sellers', width: 150 },
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

export default WithApp(function Route(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [routes, setRoutes] = useState([]); //constante para el listado

  const [showModaRouteEdit, setShowModaRouteEdit] = useState(false); //Abrir modal
  const [routeId, setRouteId] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadRoutes() {
    setDataLoading(true);
    let response = await wsGetAll('base/route');
    setDataLoading(false);
    if (response.success) setRoutes(response.data);
  }

  useEffect(() => {
    loadRoutes();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadRoutes} />
      {showModaRouteEdit ? (
        <ModalMapRouteEdit
          showModal={showModaRouteEdit}
          setShowModal={setShowModaRouteEdit}
          routeId={routeId}
          setRouteId={setRouteId}
          showNotify={showNotify}
          reload={loadRoutes}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_ROUTES_STORE}
              component={
                <CardIcon color="primary">
                  <Map style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Rutas {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Rutas"
              defaultWidth={1000}
              columns={columns}
              data={routes.map((route, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_SHOW}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => {
                            setShowModaRouteEdit(true);
                            setRouteId(route.id);
                          }}
                        >
                          <EditLocation />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(route)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_DELETED}>
                        <ButtonDelete entity="base/route" id={route.id} reload={loadRoutes} />
                      </AllowedGuard>
                    </div>
                  ),
                  code: route.code,
                  description: route.description,
                  layerColor: <LayerColorIcon layer={route.layer} />,
                  layer: route.layer.name,
                  zone: route.base_zone_description,
                  polygon: route.geometry == null ? 'No' : 'Si',
                  validate_gps: route.validate_gps == true ? 'Si' : 'No',
                  multiple_sellers: route.multiple_sellers == true ? 'Si' : 'No',
                  state: route.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
